import { Component, OnInit } from '@angular/core';
import { BoxService } from '../../services/box.service';
import { BoxMessage } from '../../models/boxmessage';
import { Router } from '@angular/router';

@Component({
  selector: 'app-debug',
  templateUrl: './box-debug.component.html',
  styleUrls: ['./box-debug.component.scss']
})
export class BoxDebugComponent implements OnInit {

  constructor(private boxService: BoxService) { }

  ngOnInit(): void {
  	
  }

}
